// ===== Factoryhouse Mega Menu – open on 'Shop' hover + preview image =====
const FH_IMAGE_FOLLOWS_CURSOR = true;

document.addEventListener('DOMContentLoaded', () => {
  const megaMenu = document.getElementById('fh-mega-menu');
  if (!megaMenu) return;

  const previewWrapper = megaMenu.querySelector('.fh-mega-menu__preview-wrapper');
  const previewImg = document.getElementById('fh-mega-menu-preview');
  if (!previewWrapper || !previewImg) return;

  // 1. Find the nav that actually contains a "Shop" item (button or link)
  const navCandidates = Array.from(document.querySelectorAll('nav'));
  let shopTrigger = null;

  for (const nav of navCandidates) {
    const triggers = Array.from(nav.querySelectorAll('button, a'));
    const found = triggers.find((el) => {
      const text = (el.textContent || '').trim().toLowerCase();
      const megaLabel = (window.FH_MEGA_MENU_LABEL || '').toLowerCase();

      return text === megaLabel;
      /*return text === 'shop';*/
    });

    if (found) {
      shopTrigger = found;
      break;
    }
  }

  if (!shopTrigger) {
    console.warn('[FH mega] Could not find a nav containing "Shop"');
    return;
  } else {
    console.log('[FH mega] Shop trigger found in nav:', shopTrigger);
  }

  // Helpers for preview image
  const showPreview = (event, item) => {
    const src = item.dataset.preview;
    if (!src) return;

    previewImg.src = src;
    previewImg.alt = item.textContent.trim();
    previewWrapper.classList.add('fh-mega-menu__preview-wrapper--visible');

    if (FH_IMAGE_FOLLOWS_CURSOR) {
      const x = event.clientX + 60;  // adjust offsets here
      const y = event.clientY + 40;

      previewWrapper.style.left = `${x}px`;
      previewWrapper.style.top = `${y}px`;
    } else {
      previewWrapper.style.left = '';
      previewWrapper.style.top = '';
    }
  };

  const updatePreviewPosition = (event) => {
    if (!FH_IMAGE_FOLLOWS_CURSOR) return;
    if (!previewWrapper.classList.contains('fh-mega-menu__preview-wrapper--visible')) return;

    const x = event.clientX + 160;
    const y = event.clientY + 60;

    previewWrapper.style.left = `${x}px`;
    previewWrapper.style.top = `${y}px`;
  };

  const hidePreview = () => {
    previewWrapper.classList.remove('fh-mega-menu__preview-wrapper--visible');
  };

  const openMega = () => {
    megaMenu.classList.add('fh-mega-menu--open');
    megaMenu.setAttribute('aria-hidden', 'false');
  };

  const closeMega = () => {
    megaMenu.classList.remove('fh-mega-menu--open');
    megaMenu.setAttribute('aria-hidden', 'true');
    hidePreview();
  };

  // 2. Open mega menu when hovering / focusing "Shop"
  shopTrigger.addEventListener('mouseenter', openMega);
  shopTrigger.addEventListener('focus', openMega);

  // 3. Close when leaving Shop and not entering the mega menu
  shopTrigger.addEventListener('mouseleave', () => {
    setTimeout(() => {
      if (!megaMenu.matches(':hover') && !shopTrigger.matches(':hover')) {
        closeMega();
      }
    }, 150);
  });

  // 4. Close when leaving the mega menu entirely
  megaMenu.addEventListener('mouseleave', () => {
    setTimeout(() => {
      if (!megaMenu.matches(':hover') && !shopTrigger.matches(':hover')) {
        closeMega();
      }
    }, 150);
  });

  // 5. Close on Escape
  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') closeMega();
  });

  // 6. Preview image on hover over sub-collection links AND column headers
  const items = megaMenu.querySelectorAll('.fh-mega-menu__item, .fh-mega-menu__col-link');

  items.forEach((item) => {
    item.addEventListener('mouseenter', (event) => {
      showPreview(event, item);
    });

    // keep following the cursor while hovering the link
    item.addEventListener('mousemove', (event) => {
      updatePreviewPosition(event);
    });

    // hide preview immediately when leaving the link
    item.addEventListener('mouseleave', () => {
      hidePreview();
    });
  });

  // 7. HARD BLOCK: disable drawer click for "Shop" on desktop via capture
  document.addEventListener(
    'click',
    (e) => {
      if (window.innerWidth < 1025) return; // keep drawer on mobile

      if (!shopTrigger) return;

      // If the click is on Shop or inside it
      if (shopTrigger.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();        // stop bubbling to Alpine's global handlers
        e.stopImmediatePropagation();

        // Toggle or open the mega menu on click if you want
        if (!megaMenu.classList.contains('fh-mega-menu--open')) {
          openMega();
        } else {
          // optional: close on second click
          // closeMega();
        }
      }
    },
    true // <-- capture phase so we run BEFORE Alpine
  );
});
